module.exports = __webpack_public_path__ + "static/media/alyssa2.97828eb6.jpg";